import React, { useState } from "react"
import "./PropertyCard.scss"
import { Row } from "react-bootstrap"
import { ShowProcessedImage } from "../common/ggfx-client/module/components/show-image"
import imageConfig from "../../../static/images/config.json"
import NoImage from "../../images/no-image.png"
import { Link } from "gatsby"
import $ from "jquery"
import { SaveItem } from "@starberry/myaccount-website-utils"
import parse from "html-react-parser"

const PropertyCard = ({
  propertyid,
  status,
  price,
  priceQualifier,
  title,
  location,
  description,
  bedroomsCount,
  receptionsCount,
  bathroomsCount,
  propertyVideo,
  propertyImages,
  propertyDetailsLink,
  propertySearchType,
  noResulttag,
  userObjects,
  savedSearchParams
}) => {
  //property description
  let text_truncate = function (str, length, ending) {
    if ($(window).width() > 1400) {
      length = 200
    } else {
      length = 160
    }
    //
    if (ending == null) {
      ending = "... "
    }
    if (str.length > length) {
      return str.substring(0, length - ending.length) + ending
    } else {
      return str
    }
  }
  function removeTags(str) {
    if (str === null || str === "") return false
    else str = str.toString()

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "")
  }
  //var propertyintro = removeTags(description);
  var propertyintro = description?.replace(/\<br\>/g, " ")?.replace(/\<p\>/g, " ")?.replace(/\<p>/g, " ")
  //property description
  return (
    <div className="property-item-wrapper">
      <Row className="property-item__row">
        <div className="property-item__row-inner">
          <div className="property-item__gallery d-md-grid">
            {propertyImages && propertyImages.length > 0 ? (
              <div className="featured-image img-zoom">
                <picture>
                  <Link to={propertyDetailsLink}>
                    {noResulttag === "noResultsProperty" ? (
                      <div className="gatsby-image-wrapper featured-image fromalg1">
                        <picture>
                          <img
                            src={propertyImages && propertyImages[0]?.hd_url || propertyImages[0]?.url}
                            alt={location + " - Sandfords"}
                          />
                        </picture>
                      </div>
                    ) :
                    (
                      <div className="gatsby-image-wrapper featured-image fromalg1">
                        <picture>
                          <img
                            src={propertyImages && propertyImages[0]?.large_url || propertyImages[0]?.url}
                            alt={location + " - Sandfords"}
                          />
                        </picture>
                      </div>
                    )
                    // (
                    //   <ShowProcessedImage
                    //     images={propertyImages && propertyImages[0]}
                    //     attr={{
                    //       className: "mb-0 img-fluid",
                    //       alt: location + " - Sandfords",
                    //     }}
                    //     transforms={imageConfig.property.searchResults.sizes}
                    //   />
                    // )
                    }
                  </Link>
                </picture>
                <Link className="btn-link" to={propertyDetailsLink}>
                  <i class="icon icon-track-slider-link-arrow"></i>
                </Link>
              </div>
            ) : (
              <div className="featured-image img-zoom">
                <picture>
                  <Link to={propertyDetailsLink}>
                    <img src={NoImage} alt={location + " - Sandfords"} />
                  </Link>
                </picture>
                <Link className="btn-link" to={propertyDetailsLink}>
                  <i class="icon icon-track-slider-link-arrow"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
        <div className="property-item__text">
          <Link to={propertyDetailsLink}>
            <h2>{location}</h2>
          </Link>
          {
            propertySearchType === "sales" ? 
            <h3>{priceQualifier} {price} </h3> 
            : 
            <h3>{price} {priceQualifier === "Weekly" ? "per week" : (priceQualifier === "Monthly" ? "per month" : priceQualifier) }</h3>
          }          
          <div className="pt-title">{title}</div>
          <div className="property-item__description">
            <p>
              {text_truncate(parse(propertyintro))}
              {<Link to={propertyDetailsLink}>read more</Link>}
            </p>
          </div>
          <span className="divider"></span>
          <div className="property-actions">
            <div className="tel-pt">
              <a href="tel:+44 20 7723 9988">
                <i className="icon-phone"></i>+44 20 7723 9988
              </a>
            </div>
            <div className="save-pt">
              <SaveItem type="property" pid={propertyid} userObjects={userObjects}>
                <a className="show-search">
                  <i className="icon-heart"></i>Save
                </a>
                <a className="remove-search">
                  <i className="icon-heart-fill"></i>Saved
                </a>
              </SaveItem>
            </div>
          </div>
        </div>
      </Row>
    </div>
  )
}

export default PropertyCard
